<template>
  <div :class="['tq-dialog',isOnlyTextHeader && 'center']">
    <el-dialog v-bind="attrs">
      <template v-for="(_, name) in slots" #[name]="slotData">
        <slot v-if="name === 'default'"></slot>
        <slot v-else :name="name" v-bind="slotData"></slot>
      </template>
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
defineOptions({
  name: "TqDialog",
});
import { getCurrentInstance, computed } from "vue";

const instance = getCurrentInstance()?.proxy;

const slots = instance?.$slots;

const attrs = instance?.$attrs;

const isOnlyTextHeader = computed(() => {
  if (slots && slots.header) {
    const headerLen = slots.header().length;
    return headerLen === 1;
  }
  return false;
});
</script>
